module.exports = __webpack_public_path__ + "static/media/mastercard.43501785.svg";